import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compact, indexOf, filter } from 'lodash';
import { Tab, Tabs, Tooltip, OverlayTrigger } from 'react-bootstrap';
import {
  getUser, getIsSuperAdmin, getIsAdmin, getIsPIUser,
  getUserCurrentOrganization,
} from '../../../Auth/AuthReducer';
import SalesRepTable from './SaleRepTable';
import NumberDisplay from '../../../../components/number-display';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const {
      canSeeAllPages, user, organization,
      threshold, owners,
    } = this.props;
    const organizationRole = user.organization_role;
    const organizationRules = organization ? organization.role_access_rules || {} : {};
    const organizationRoleRules = organizationRules[organizationRole] || {};
    const features = organization ? organization.features : {};
    const thresholdComp = (
      <NumberDisplay value={threshold} suffix="%" precision={1} />
    );
    const menus = [
      {
        key: 'leaderboard_leader',
        label: 'Leader List',
        tip: (
          <span>Users that have requested feedback for at least {thresholdComp} of their closed opportunities</span>
        ),
      },
      {
        key: 'leaderboard_naughty',
        label: 'Naughty List',
        tip: (
          <span>Users that have requested feedback for less than {thresholdComp} of their closed opportunities</span>
        ),
      },
    ];
    const items = compact(menus.map((menu) => {
      const siteEnabled = features[menu.key] === true;
      const permissionEnabled = indexOf(['ALL', 'OWNERSHIP'], organizationRoleRules[menu.key]) >= 0;
      const featureEnabled = siteEnabled && permissionEnabled;
      if ((canSeeAllPages || featureEnabled)) {
        let salesReps = filter(owners, { isNaughty: menu.key === 'leaderboard_naughty' });
        if (organizationRoleRules[menu.key] === 'OWNERSHIP') {
          salesReps = filter(salesReps, { user_id: user.user_id });
        }
        return {
          ...menu,
          count: salesReps.length,
          salesReps,
        };
      }
      return null;
    }));

    if (items.length === 0) {
      return null;
    }

    return (
      <div>
        <Tabs mountOnEnter unmountOnExit defaultActiveKey={items[0].key} animation={false} id="leaders-tab">
          {items.map((item) => {
            let title = (
              <span>{item.label}{item.count > 0 ? <span>&nbsp;<span className="badge"><NumberDisplay precision={0} value={item.count} /></span></span> : null}</span>
            );
            if (item.tip) {
              const tip = (
                <Tooltip id={item.key}>{item.tip}</Tooltip>
              );
              title = (
                <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tip}>
                  {title}
                </OverlayTrigger>
              );
            }
            return (
              <Tab
                key={item.key}
                eventKey={item.key}
                title={title}
              >
                <div>
                  <p />
                  <SalesRepTable
                    owners={item.salesReps}
                    threshold={threshold}
                    requestShowDeals={this.props.requestShowDeals}
                  />
                </div>
              </Tab>
            );
          })}
        </Tabs>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const isAdmin = getIsAdmin(state);
  const isSuperAdmin = getIsSuperAdmin(state);
  const isPIUser = getIsPIUser(state);
  const userCurrentOrganization = getUserCurrentOrganization(state);
  const user = getUser(state);
  let canSeeAllPages = false;
  if (isAdmin || isSuperAdmin) {
    canSeeAllPages = true;
  } else if (isPIUser && user && userCurrentOrganization && indexOf(user.organization__ids, userCurrentOrganization._id) >= 0) {
    canSeeAllPages = true;
  }
  return {
    user,
    organization: userCurrentOrganization,
    canSeeAllPages,
  };
}

List.propTypes = {
  owners: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  canSeeAllPages: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    user_id: PropTypes.string.isRequired,
    organization_role: PropTypes.string.isRequired,
  }).isRequired,
  organization: PropTypes.shape({
    role_access_rules: PropTypes.shape({}).isRequired,
    features: PropTypes.shape({}).isRequired,
  }).isRequired,
  threshold: PropTypes.number.isRequired,
  requestShowDeals: PropTypes.func,
};

List.defaultProps = {
  requestShowDeals: () => {},
};

List.contextTypes = {
};
export default connect(mapStateToProps)(List);
